/**
 * CartTimer.jsx
 * Created by Destin Frasier on 7/26/17.
 * Enhancements added by Betty Huang on 8/10/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import * as Icons from './icons/Icons';

const propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    onComplete: PropTypes.func
};

export default class CartTimer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            timer: null,
            timeRemaining: 0
        };

        this.tick = this.tick.bind(this);
    }

    componentWillMount() {
        const timer = setInterval(() => this.tick(), 1000);
        this.setState({ timer });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    tick() {
        this.setState({
            timeRemaining: -1 * moment().diff(this.props.date)
        });
        if (this.state.timeRemaining <= 0) {
            if (this.props.onComplete) {
                this.props.onComplete();
            }
            clearInterval(this.state.timer);
        }
    }

    formatTime(num) {
        if (num <= 0) {
            return '00';
        }
        return num < 10 ? `0${num}` : num.toString();
    }

    renderTime() {
        const hh = this.formatTime(moment.duration(this.state.timeRemaining).get('hours'));
        const mm = this.formatTime(moment.duration(this.state.timeRemaining).get('minutes'));
        const ss = this.formatTime(moment.duration(this.state.timeRemaining).get('seconds'));

        let time = <time>{hh}:{mm}:{ss}</time>;

        // Hide hours if the remaining time is shorter than 60 minutes
        if (hh === '00') {
            time = <time>{mm}:{ss}</time>;
        }

        return time;
    }

    render() {
        return (
            <div className="rec-timer">
                <Icons.IconHourglassHalf />
                <div className="rec-timer-text">Reservation held for:</div>{this.renderTime()}
            </div>
        );
    }
}

CartTimer.propTypes = propTypes;
